var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 109,
    viewBox: "0 0 90 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 34.6818V49.5455H65V34.6818C65 29.2112 63.0469 24.5405 59.1406 20.6697C55.2344 16.799 50.5208 14.8636 45 14.8636C39.4792 14.8636 34.7656 16.799 30.8594 20.6697C26.9531 24.5405 25 29.2112 25 34.6818ZM87.8125 51.7131C89.2708 53.1581 90 54.9129 90 56.9773V101.568C90 103.633 89.2708 105.387 87.8125 106.832C86.3542 108.277 84.5833 109 82.5 109H7.5C5.41667 109 3.64583 108.277 2.1875 106.832C0.729167 105.387 0 103.633 0 101.568V56.9773C0 54.9129 0.729167 53.1581 2.1875 51.7131C3.64583 50.268 5.41667 49.5455 7.5 49.5455H10V34.6818C10 25.1856 13.4375 17.0312 20.3125 10.2187C27.1875 3.40625 35.4167 0 45 0C54.5833 0 62.8125 3.40625 69.6875 10.2187C76.5625 17.0312 80 25.1856 80 34.6818V49.5455H82.5C84.5833 49.5455 86.3542 50.268 87.8125 51.7131Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 109,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6066087ccf770fc4b2df35d6af1aca93.svg";
export { ForwardRef as ReactComponent };